import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Tooltip from "@material-ui/core/Tooltip";
import RefreshIcon from '@material-ui/icons/Refresh';
import PaymentIcon from '@material-ui/icons/Payment';
import CircularProgress from '@material-ui/core/CircularProgress';
import CropFreeIcon from '@material-ui/icons/CropFree';
import DatasetLinked from "@mui/icons-material/DatasetLinked"

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import PagamentoVendaEfetuada from "beaktClinic/views/Venda/PagamentoVendaEfetuada.js";
import QrCodeBeaktPix from "beaktClinic/views/Venda/Pagamentos/QRCodeBeaktPix";

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";

//services
import { useGetApi, UsePostApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { formateDateandTime } from "beaktShared/helpers/masks";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

export default function VendasEmAndamento() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);

    const endPointGet = "vendas/unfinished/" + session.estabelecimentoId;
    const [{ list, isLoadingList, isErrorGetList }, setListAtualiza] = useGetApi(endPointGet);
    
    const [loadingAcoes, setloadingAcoes] = React.useState(false);
    const statusPagamentoVenda = (vendaId, vendaPagamentoId) => {
        setloadingAcoes(true);
        let endPoint = "vendas/StatusPagamento/" + vendaId + '/' + vendaPagamentoId;
        setListAtualiza({ isLoadingList: true });
        UsePostApi(endPoint, null).then(result => {
            if (result.status !== 200) {
                setListAtualiza({ isLoadingList: false });
                showAlert(result.message.message, 'warning');
                setloadingAcoes(false);
                return false;
            }

            if (result.data.status === 4 || result.data.status === 3) {
                set_vendaQRCode(null);
                showAlert(result.data.mensagem, 'success');
                setListAtualiza({ isLoadingList: true });
                UseGetApiSimple(endPointGet).then(result => {
                    setListAtualiza({ list: result, isLoadingList: true });
                });
            }
            else if (result.data.status === 2) {
                showAlert(result.data.mensagem, 'warning');
            }
            else {
                UseGetApiSimple(endPointGet).then(result => {
                    setListAtualiza({ list: result, isLoadingList: true });
                });
                showAlert(result.data.mensagem, 'warning');
            }

            setloadingAcoes(false);
        });
    };;
    
    const [alert, setalert] = React.useState();
    const showAlert = (message, tipo) => {
        setalert(<SweetAlert
            warning={tipo === 'warning' ? true : false}
            success={tipo === 'success' ? true : false}
            title="Aviso"
            onConfirm={() => setalert(null)}
        >
            <div dangerouslySetInnerHTML={{ __html: message }} />
        </SweetAlert>);
    };

    const [venda, setvenda] = React.useState(null);
    const [vendaClienteId, setVendaClienteId] = React.useState(null);
    const handlePagamentoVendaClick = (data) => {
        setloadingAcoes(true);
        const endPoint = "vendas/detalhevendarealizada/" + data.vendaId;
        UseGetApiSimple(endPoint).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');    
                setloadingAcoes(false);
                return false;
            }
            setvenda(result.data);
            setVendaClienteId(data.clienteId);
            setloadingAcoes(false);
            return true;
        });
    };;
    
    const handleReturnPagamento = () => {
        setvenda(null);
        setListAtualiza({ isLoadingList: true });
        UseGetApiSimple(endPointGet).then(result => {
            setListAtualiza({ list: result.data, isLoadingList: false });
        });
    };;
        
    const [vendaQRCode, set_vendaQRCode] = React.useState(null);
    
    const handleCopyLink = (customUrl) => {
        const url = customUrl;

        if (!url) {
            showAlert('Nenhum link disponível para copiar.', 'warning');
            return;
        }

        navigator.clipboard.writeText(url)
            .then(() => {
                showAlert('Link copiado com sucesso.', 'success');
            })
            .catch(err => {
                showAlert('Erro ao copiar o link: ' + err, 'error');
            });
    };
    
    const columnsProp = [{
        Header: t('label.date'),
        accessor: "dataCadastro",
        Cell: (props) => {
            let custom_date = formateDateandTime(props.value);
            return <span>{custom_date}</span>
        }
    },
    {
        Header: t('label.client_name'),
        accessor: "clienteNome"
    },
    {
        Header: t('dashboard.sale_number'),
        accessor: "vendaId"
    },
    {
        Header: t('label.status'),
        accessor: "statusVendaDesc"
    },
    {
        Header: t('label.payment_method'),
        accessor: 'formaPagamentoDesc',
    }]
    const columnsAcao = [
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">
                    {
                        (
                            row.original.statusVendaDesc === 'Aguardando processamento pagamento' &&
                            row.original.urlPagamento
                        ) &&
                        (
                            <>
                                <Button 
                                    onClick={() => handleCopyLink(row.original.urlPagamento)}
                                    justIcon round simple 
                                    color="info">
                                    <Tooltip 
                                        title={t('button.copy_payment_link')}
                                        id="tooltip-top" 
                                        placement="top"
                                        classes={{ tooltip: classes.tooltip }}>
                                        <DatasetLinked/>
                                    </Tooltip>
                                </Button>
                            </>
                        )
                    }
                    {
                        row.original.statusVendaDesc === 'Aguardando processamento pagamento' &&
                        <Button justIcon round simple color="warning"
                            onClick={() => statusPagamentoVenda(row.original.vendaId, row.original.vendaPagamentoId)}>
                            <Tooltip title={t('button.update_status')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                <RefreshIcon />
                            </Tooltip>
                        </Button>
                    }
                    {
                        row.original.statusVendaDesc === 'Aguardando processamento pagamento' && row.original.qrCodeBeaktPix &&
                        <Button justIcon round simple color="info"
                            onClick={() => set_vendaQRCode(row.original)}>
                            <Tooltip title={t('button.qr_code')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                <CropFreeIcon />
                            </Tooltip>
                        </Button>
                    }
                    {(
                        row.original.statusVendaDesc === "Pagamento Estornado" ||
                        (
                            row.original.statusVendaDesc === "Em Andamento" &&
                            row.original.formaPagamentoDesc === "Dr Sim"
                        )
                        ) && (
                        <Button justIcon round simple color="success"
                            onClick={() => handlePagamentoVendaClick(row.original)}>
                            <Tooltip
                            title={t('label.make_the_payment')}
                            id="tooltip-top"
                            placement="top"
                            classes={{ tooltip: classes.tooltip }}
                            >
                            <PaymentIcon />
                            </Tooltip>
                        </Button>
                    )}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp, ...columnsAcao]

    const classes = useStyles();
    return (
        <div>
            {alert}
            {loadingAcoes &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }
            <GridContainer>
                
                {venda === null &&
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <Assignment />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>{t('sidebar.sales_awaiting_card_processing')} </h4>
                            </CardHeader>
                            <CardBody>

                                <Link to="/adminclinic/venda" >
                                    <Button
                                        color="primary"
                                        className={classes.newButton}
                                    >
                                        {t('sidebar.new_sale')}
                                    </Button>
                                </Link>

                                {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                                <ReactTable
                                    loading={isLoadingList}
                                    data={list}
                                    columns={columns}
                                    filterable
                                    defaultFilterMethod={noCaseSensitive}
                                    defaultPageSize={10}
                                    minRows={5}
                                    showPaginationBottom={true}
                                    className="-striped -highlight"
                                    previousText={t('button.previous')}
                                    nextText={t('button.next')}
                                    loadingText={t('label.loading') + "..."}
                                    noDataText={t('information_message.no_records_found') + "!"}
                                    pageText={t('label.page')}
                                    ofText={t('label.of')}
                                    rowsText={t('label.rows')}
                                />
                            </CardBody>
                        </Card>
                    </GridItem>
                }
                {venda !== null &&
                    <PagamentoVendaEfetuada 
                        venda={{ venda }} 
                        CallbackVendasEmAndamento={handleReturnPagamento}
                        clienteId={vendaClienteId}>
                    </PagamentoVendaEfetuada>
                }

            </GridContainer>

            {vendaQRCode &&
                <QrCodeBeaktPix qrCodeBeaktPix_value={vendaQRCode.qrCodeBeaktPix} showModal={true} closeModal={() => set_vendaQRCode(null)} atualizarStatus={() => statusPagamentoVenda(vendaQRCode.vendaId)}></QrCodeBeaktPix>
            }

        </div>
    );
}